<footer class="footer">
  <div class="footer-inner">
    <div class="footer-brand">
      <picture>
        <source srcset="./assets/images/logo_advisors_weiß.webp" type="image/webp" />
        <img src="./assets/images/logo_advisors_weiß.png" alt="msg advisors" class="footer-logo" />
      </picture>

      <nav class="footer-links" aria-label="Legal">
        <a routerLink="/imprint">{{ 'footer.imprint' | translate }}</a>
        <a routerLink="/privacy">{{ 'footer.privacy' | translate }}</a>
        <a routerLink="/contact">{{ 'footer.contact' | translate }}</a>
      </nav>
    </div>

    <div class="footer-about">
      <section class="footer-about-block footer-about-block--large">
        <h3 class="footer-about-title">
          {{ 'footer.aboutThe' | translate }}
          <span class="brand-accent">{{ 'footer.msgSecurityAdvisors' | translate }}</span>
        </h3>
        <p class="footer-about-text">{{ 'footer.aboutMsgSecurityDescription' | translate }}</p>
      </section>

      <section class="footer-about-block">
        <h3 class="footer-about-title">
          {{ 'footer.aboutMsg' | translate }}
          <span class="brand-accent">{{ 'footer.msg' | translate }}</span>
        </h3>
        <p class="footer-about-text">{{ 'footer.aboutMsgDescription' | translate }}</p>
      </section>
    </div>
  </div>
</footer>
